import React, { useMemo } from "react";
import AppNav from "../../header/AppNav";

import SuperAdminAshaView from "./views/SuperAdminAshaView";
import TalukAshaView from "./views/TalukAshaView";
import PhcAshaView from "./views/PhcAshaView";
import AshaBlockAshaView from "./views/AshaBlockAshaView";

function Asha() {
  const user = JSON.parse(localStorage.getItem("user"));

  const { isSuperAdmin, isTaluk, isPhc, isAshaBlock } = useMemo(() => ({
    isSuperAdmin: user?.roleDetails?.role === "Super Admins",
    isTaluk: user?.roleDetails?.role === "Taluk",
    isPhc: user?.roleDetails?.role === "PHC",
    isAshaBlock: user?.roleDetails?.role === "Asha Block",
  }), [user]);

  return (
    <div>
      <AppNav />
      <h1 className="list-style">Ashas</h1>
      <div className="list-table-style">
        {isSuperAdmin && <SuperAdminAshaView />}
        {isTaluk && <TalukAshaView />}
        {isPhc && <PhcAshaView />}
        {isAshaBlock && <AshaBlockAshaView />}
      </div>
    </div>
  );
}

export default Asha;
